import type { ReactNode } from 'react';
import { Fragment } from 'react';
import { Inline } from '@etg/wings';
import { css, cx } from '@eti/styles';

const whiteSpaceStyles = css`
  white-space: pre-wrap;
`;

interface BidirectionalSeparatedElementsProps {
  ariaHidden?: boolean;
  className?: string;
  'data-testid'?: string;
  elements: ReactNode[];
  separator?: ReactNode;
}

// TODO BidirectionalSeparatedElements component does not work when it is nested used. It can possibly be removed.
//  A simple <bdi> element, fed with the text we want to render structured exactly as it should be, can achieve the same functionality.
//  Range of numbers and hours should be rendered in separate <bdi> elements, as they are read from left to right in all languages.
//  Each example should better be tested with arabic words, as when tested in English the result might not be correct.
export const BidirectionalSeparatedElements = ({
  ariaHidden = false,
  className,
  'data-testid': dataTestId,
  elements,
  separator = ' - ',
}: BidirectionalSeparatedElementsProps) => {
  return (
    <Inline
      alignY="center"
      aria-hidden={ariaHidden}
      className={cx(className, whiteSpaceStyles)}
      data-testid={dataTestId}
      spacing={0}
    >
      {elements.map((element, index, arr) => (
        <Fragment key={`${element}-${index}`}>
          {/* bdi is used here because even if in English it seems not to work as expected, when the arabic translation exists it handles it properly.
           In Arabic numbers and hours are read from left to right. This applies also to hour duration (13:00 - 14:00). */}
          <bdi>{element}</bdi>
          {index < arr.length - 1 && <bdi>{separator}</bdi>}
        </Fragment>
      ))}
    </Inline>
  );
};

export default BidirectionalSeparatedElements;
